module.exports = __webpack_public_path__ + "static/media/Host Asset 1.a09c15de.svg";